import Service from '@/helpers/service'

export default {

    getReport(params) {
        return Service().get('report-inventory/goods-usage-report', {params});
    },
}